import { Routes, RouterModule } from "@angular/router";
import { WorklogsListComponent } from "./worklogs-list.component";
import { WorklogDetailsModule } from "../worklog-details/worklog-details.module";
import { WorklogDetailsComponent } from "../worklog-details/worklog-details.component";
import { WorklogDetailsIssueModule } from "../worklog-details/worklog-details-issue.module";

const routes: Routes = [
    { path: '', component: WorklogsListComponent },
    { path: 'worklog', loadChildren: () =>WorklogDetailsIssueModule },
  ];

  export const WorklogsListRouting = RouterModule.forChild(routes);